
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 14","fill":"#0D69D5","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.866 3.127h8.884a.629.629 0 00.626-.627.629.629 0 00-.626-.626H6.866a.629.629 0 00-.627.626c0 .345.282.627.627.627zM15.746 6.865h-5.33a.629.629 0 00-.626.627c0 .345.282.627.626.627h5.33a.629.629 0 00.627-.627.629.629 0 00-.627-.627zM15.746 11.456h-5.33a.629.629 0 00-.626.627c0 .345.282.627.626.627h5.33a.629.629 0 00.627-.627.629.629 0 00-.627-.627zM6.985 5.716H4.967a.769.769 0 00-.768.767v.386H2.617V4.32h.542a.769.769 0 00.768-.768V1.538a.769.769 0 00-.768-.767H1.14a.769.769 0 00-.768.767v2.018c0 .424.345.768.768.768h.222v7.85c0 .345.282.627.627.627H4.2v.382c0 .423.344.768.767.768h2.018a.769.769 0 00.768-.768v-2.018a.769.769 0 00-.768-.768H4.967a.769.769 0 00-.768.768v.382H2.617V8.125h1.582v.376c0 .423.345.768.768.768h2.018a.769.769 0 00.768-.768V6.483a.769.769 0 00-.768-.767z"}})])
          )
        }
      }
    